module.exports = __webpack_public_path__ + "static/media/location.6cc3d444.svg";